import { RouterManager } from '@aclass/admin/managers';
import { ConsentStory } from '@aclass/admin/storage/actions';
import { IAdminState, IConsentModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class ConsentSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:consent-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IConsentModuleState['searchPageInitialized']>(['consentModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(ConsentSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(ConsentStory.dryRunSearchPage());
    }
}
